/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * TenFrame.tsx - Ten Frame layout.
*/

import { StyleSheet, View } from 'react-native';
import TenFrameElement from './TenFrameElement';
import { calculateHorizontalTenFrameSize } from './TenFrameSizes';

import type { JSX } from 'react';

interface TenFrameProps {
  numFrames: number;
  numReds: number;
  numYellows: number;
  usableWidth: number;
  usableHeight: number;
  isSubtract?: boolean;
  
}

const TenFrame = ({numFrames, numReds, numYellows, usableWidth, usableHeight, isSubtract}: TenFrameProps) : JSX.Element => {

  // A ten frame consists of two rows of 5 counters to 
  // represent a number between 0 and 10
  const {usableElementSize, elementMargin} = calculateHorizontalTenFrameSize(numFrames, usableWidth, usableHeight);

  // 2 rows, 5 columns
  const numRows = 2;
  const numCols = 5;
  const rows = [];

  // Fill each column and row with the reds, subtraction reds, yellows or empties.
  for (let i = 0; i < numRows; i++) {
    const cols = [];
    for (let j = 0; j < numCols; j++) {

      if ( numReds > 0) {
        cols.push(
          <TenFrameElement color="red" isFilled width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`red${i}-${j}`} />
        );
        numReds -= 1;
      }
      else if(isSubtract){
        // In subtraction questions the numYellows variable is used to show the amount to subtract. 
        if ( numYellows > 0){
          cols.push(
            <TenFrameElement color="red" isFilled isSubtract width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`subtract$${i}-${j}`} />
          );
          numYellows -= 1;
        }
        else {
          cols.push(
            <TenFrameElement color="none" isFilled={false} width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`empty$${i}-${j}`} />
          );
        }
      }
      else if (numYellows > 0 ) {
        cols.push(
          <TenFrameElement color="yellow" isFilled width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`yellow${i}-${j}`} />
        );
        numYellows -= 1;
      }
      else {
        cols.push(
          <TenFrameElement color="none" isFilled={false} width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`empty$${i}-${j}`} />
        );
      }
    }

    rows.push(
      <View style={styles.row} key={`row${i}`}>
        {cols}
      </View>
    );
  }
 
  return (
    <View style={styles.frameWrapper} key='frameWrapper'>
      <View style={styles.tenFrame} key='tenFrame'>
        {rows}
      </View>
    </View>
  );
};

export default TenFrame;

const styles = StyleSheet.create({

  frameWrapper: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
  },

  tenFrame: {
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#20232a',
    borderStyle: 'solid',
    backgroundColor: 'grey',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
  },

  row: {
    flexDirection: 'row'
  }
});
